import type { EventCardProps } from './types'

export default function EventCard({ image, eventType, title, location, date, url, isExternal }: EventCardProps) {
	return (
		<article className="group relative flex flex-col gap-6 lg:flex-row lg:gap-16">
			<a
				href={url}
				className="absolute inset-0 z-10"
				aria-label={title}
				target={isExternal ? '_blank' : undefined}
				rel={isExternal ? 'noopener noreferrer' : undefined}
			/>

			{image ? (
				<figure className="w-full aspect-333/218 overflow-hidden rounded-xs shrink-0 lg:w-83">
					<img
						src={image.src}
						alt={image.alt ?? ''}
						className="w-full h-full object-cover transition-opacity duration-200 ease-out group-hover:opacity-90"
					/>
				</figure>
			) : (
				<div className="hidden lg:block lg:aspect-333/218 lg:w-83 lg:shrink-0" aria-hidden="true" />
			)}

			<div className="flex flex-col gap-3 lg:flex-1 lg:min-w-0 lg:max-w-200 lg:self-stretch lg:justify-center">
				{eventType && <p className="body-small text-black-950 uppercase">{eventType}</p>}

				<h3 className="h3 text-black-950 line-clamp-2 group-hover:underline transition-colors duration-200 ease-out">
					{title}
				</h3>

				{(location || date) && (
					<div className="flex items-center gap-[0.6875rem]">
						{location && <p className="body-small font-semibold text-black-950">{location}</p>}
						{date && <p className="body-small text-black-950">{date}</p>}
					</div>
				)}
			</div>
		</article>
	)
}
